module.exports = __webpack_public_path__ + "img/swiper-arrow.ed83fad7.svg";